import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TabNavigationService } from '../../../services/tab-navigation.service';
import { ScrollService } from '../../../services/page-scroll.service';

@Component({
    selector: 'app-step-3',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './step-3.component.html',
    styleUrl: './step-3.component.scss',
})
export class Step3Component implements OnChanges {
    @Input() data: any;
    checklist: any = [];
    gaId: any = '';

    constructor(
        private tabNavigationService: TabNavigationService,
        private scrollService: ScrollService
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['data']) {
            const chData = changes?.data?.currentValue;
            this.gaId = chData?.switcher1group + '_download_button_jc3_click';
            for (let i = 1; i <= 10; i++) {
                if (chData[`checklist${i}`]) {
                    this.checklist.push(chData[`checklist${i}`]);
                }
            }
        }
    }

    navigateToTabs(mainTab: string, subTab: string) {
        this.tabNavigationService.navigateToTab(mainTab, subTab);
    }

    scrollToTop() {
        this.scrollService.scrollToPosition(0, 'smooth');
    }
    implementTabs = [
        'Explore available financing and incentives to carry out planned ESG-related initiatives.',
        'Communicate progress made to key stakeholders on a frequent basis (this may likely include, among others, the sharing of critical ESG data) using their preferred channels.',
        'Consider disclosing your ESG efforts and/or performance publicly via your company’s website, publication of a sustainability report or through a digital ESG disclosure platform.',
        'Consider obtaining green certification(s) to enhance overall credibility of ESG initiatives undertaken and/or ESG data disclosed.',
    ];
}
